var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarDays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fa-secondary{opacity:.4}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 192V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V192H0ZM128 432C128 440.836 120.838 448 112 448H80C71.164 448 64 440.836 64 432V400C64 391.164 71.164 384 80 384H112C120.838 384 128 391.164 128 400V432ZM128 304C128 312.836 120.838 320 112 320H80C71.164 320 64 312.836 64 304V272C64 263.164 71.164 256 80 256H112C120.838 256 128 263.164 128 272V304ZM256 432C256 440.836 248.838 448 240 448H208C199.164 448 192 440.836 192 432V400C192 391.164 199.164 384 208 384H240C248.838 384 256 391.164 256 400V432ZM256 304C256 312.836 248.838 320 240 320H208C199.164 320 192 312.836 192 304V272C192 263.164 199.164 256 208 256H240C248.838 256 256 263.164 256 272V304ZM384 432C384 440.836 376.838 448 368 448H336C327.164 448 320 440.836 320 432V400C320 391.164 327.164 384 336 384H368C376.838 384 384 391.164 384 400V432ZM384 304C384 312.836 376.838 320 368 320H336C327.164 320 320 312.836 320 304V272C320 263.164 327.164 256 336 256H368C376.838 256 384 263.164 384 272V304Z",
    className: "fa-secondary",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400 64H352V32C352 14.327 337.673 0 320 0H320C302.327 0 288 14.327 288 32V64H160V32C160 14.327 145.673 0 128 0H128C110.327 0 96 14.327 96 32V64H48C21.49 64 0 85.49 0 112V192H448V112C448 85.49 426.51 64 400 64Z",
    className: "fa-primary",
    fill: "#c5c5c5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDays);
export default __webpack_public_path__ + "static/media/calendar-days.2c71648c.svg";
export { ForwardRef as ReactComponent };